class SearchEngine {

	search(params) {
		return Promise.resolve({});
	}


	track(params) {
		return Promise.resolve({});
	}


	supportPagination() {
		return true;
	}

}


export default SearchEngine;
